/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Billing_Voucher_RemoveInputs */

const en_billing_voucher_remove = /** @type {(inputs: Billing_Voucher_RemoveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Remove`)
};

const id_billing_voucher_remove = /** @type {(inputs: Billing_Voucher_RemoveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hapus`)
};

/**
* | output |
* | --- |
* | "Remove" |
*
* @param {Billing_Voucher_RemoveInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const billing_voucher_remove = /** @type {((inputs?: Billing_Voucher_RemoveInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Billing_Voucher_RemoveInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_billing_voucher_remove(inputs)
	return en_billing_voucher_remove(inputs)
});